import React, {  useRef, useState } from 'react';

import styled from 'styled-components'
import './addpost.css'
import { getAuth, } from "firebase/auth";
import { setDoc, doc, serverTimestamp } from "firebase/firestore"; 
import { getFirestore } from "firebase/firestore"
import {  ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {ref,uploadBytesResumable, getDownloadURL} from "firebase/storage"
import {storage} from '../../../firebase/config'






const AddPostDashBoard = () => {

    const [progress,setProgress] = useState(0);
    const formref = useRef();
    const auth = getAuth();
    const db = getFirestore()
    const [uploadImg, setUploadImg] = useState(null)
    const[title,setTitle] = useState(null)
    
    
    
    const[article, setArticle] = useState({
        title: '',
        description:'',
        image:''
    });
  
        
    const handleChange = (e) => {
        
        if(e.target.name === 'title'){
            setArticle({...article, title: e.target.value})
        }
        
        if(e.target.name === 'description'){
            setArticle({...article, description: e.target.value})
        }
       
        
    }
     
    const uploadedFiles = (file) => {

        if(!file) return;
        const storageRef = ref(storage,`/files/${article.title}.jpg`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on("state_changed", (snapshot) => {
            const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            setProgress(prog)
        }, (err) => console.log(err),
        ()=>{
            getDownloadURL(uploadTask.snapshot.ref)
           
        }
        )


    }

   



    const handleClick = async (e) => {
        e.preventDefault()

        const timestamp = serverTimestamp()

      

            
          
            

     

        await setDoc(doc(db, "articles", article.title ), {
        title: article.title,
        description: article.description,
        img: article.image,
        createdAt: timestamp
        
        
        });

        
        toast.success('Article enregistré!', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });

        
        await setArticle({ title: '',
        description: '',
        image: ''})
          
      

         }
         
         const formHandler = (e) => {
             e.preventDefault();
             const file = e.target[0].files[0];
             uploadedFiles(file);
             setArticle({...article, image:'ok'})
         }
        
             
    
   
    

    return (
        <Container>
            <ToastContainer/>

            <div className="content">
              < div className='forme'  > 
                
                    <label htmlFor="title">Titre Article</label>
                    <input maxLength={80} className="input" type="text" name="title" id="title"  onChange={handleChange} value={article.title} />
                   <form  encType="multipart/form-data" method='post' action='#' onSubmit={formHandler}>   
                   <div className="field">                
                        <input type="file" name="fileImg" id="fileImg"  />                 
                        <button>Upload</button>
                    </div>
                    
                     <span id='progress'>Téléchargé {progress} %</span>
                     </form>
                    
                    <label htmlFor="description">Ecrivez votre article</label>
                   
                    <textarea onChange={handleChange} value={article.description} className='area'  name="description" id="description" cols={30} rows={10} maxLength={350} placeholder='La description doit contenir au minimum 15caractères'></textarea>
                    
                    <div className="footer">
                      <p className='buttonAddpost'  onClick={handleClick}>Publier</p> 
                     
                   

                    </div>
            
                </div> 

                
           
            </div>

        </Container>
    );


};

const Container = styled.div`
height: 100%;
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

.content{
    width: 92%;
    height: 100%;
   
    display:flex;
    justify-content: center;
    align-items: center;

    form{
        display:flex;
        flex-direction: column;
        padding: 10px 0px;
        border: 1px solid #ccc;
        border-radius: 5px;
        
        justify-content: center;
        align-items:center;
        gap: 5px;
        width: 98%;
        margin:auto;
        margin-top: 10px;
        background: #f7f7f7;

        field{
            display:flex;
            flex-direction:row;
            justify-content: space-between;
            align-items:center;
            width: 100%;
            
        }

        
       
        #progress{
            font-size: 14px;
            font-family:'Poppins';
        }
        button{
            
            border: none;
            color:#fff;
            background:#333;
            border-radius: 5px;
            padding: 5px 10px;
        }
    }

    .form{
    position: relative;
    top: 100px;
    
    width: 50%;
    height: 100%;
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items:flex-start;
    gap: 12px;

    
       
    
  
    
}


}


    
}
`

export default AddPostDashBoard;